import styled from '@emotion/styled';
import { ICustomTheme } from 'interfaces';

export const StyledBasicTextWithUIGuidelines = styled.div<{
  theme: ICustomTheme;
  color?: string;
  fontWeight?: string | number;
  isMobile?: boolean;
  margin?: string;
}>`
  display: inline-block;
  margin: ${({ margin }) => margin || 'none'};
  color: ${({ color }) => color || 'black'};
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  font-size: ${({ isMobile, theme }) =>
    `${
      isMobile
        ? theme.fontSizes.mobileBasicText
        : theme.fontSizes.desktopBasicText
    }px`};
`;
